export const createPatchEinwilligungByInstallerIdData = (dsgvoAddressPublic, dsgvoCanSendMail) => ({
  input: {
    zuAdressveroeff: dsgvoAddressPublic ? 'Ja' : 'Nein',
    zuInfoversand: dsgvoCanSendMail ? 'Ja' : 'Nein',
  },
});
